import { render } from "./TagTemplates.vue?vue&type=template&id=434357b3&scoped=true"
import script from "./TagTemplates.vue?vue&type=script&lang=js"
export * from "./TagTemplates.vue?vue&type=script&lang=js"

import "./TagTemplates.vue?vue&type=style&index=0&id=434357b3&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-434357b3"]])

export default __exports__